/// <amd-module name="Feed/Admin/Redux/GlobalSettings/GlobalSettingsActions" />
import { ActionsUnion, createAction, trackedAction } from "redux/Utils/ActionHelper";

import { IGlobalPermissionData } from "../../Types";

export const enum GlobalSettingsActionTypes {
    // User Actions
    LoadPermissions = "Feed/GlobalSettings/LoadPermissions",
    SavePermissions = "Feed/GlobalSettings/SavePermissions",

    // API Actions
    LoadStarted = "#api/Feed/GlobalSettings/LoadPermissionData_Started",
    LoadCompleted = "#api/Feed/GlobalSettings/LoadPermissionData_Completed",
    LoadFailed = "#api/Feed/GlobalSettings/LoadPermissionData_Failed",
    SaveStarted = "#api/Feed/GlobalSettings/SavePermissionData_Started",
    SaveCompleted = "#api/Feed/GlobalSettings/SavePermissionData_Completed",
    SaveFailed = "#api/Feed/GlobalSettings/SavePermissionData_Failed",

    // UI Actions
    SetError = "UI/GlobalSettings/SetError"
}

export const GlobalSettingsActions = {
    // User Actions
    loadPermissions: () => createAction(GlobalSettingsActionTypes.LoadPermissions),
    savePermissions: (data: IGlobalPermissionData) =>
        trackedAction(createAction(GlobalSettingsActionTypes.SavePermissions, { data })),

    // API Actions
    loadStarted: () => createAction(GlobalSettingsActionTypes.LoadStarted),
    loadCompleted: (data: IGlobalPermissionData) => createAction(GlobalSettingsActionTypes.LoadCompleted, { data }),
    loadFailed: (errorMessage: string | undefined) =>
        createAction(GlobalSettingsActionTypes.LoadFailed, { errorMessage }),
    saveStarted: () => createAction(GlobalSettingsActionTypes.SaveStarted),
    saveCompleted: () => createAction(GlobalSettingsActionTypes.SaveCompleted),
    saveFailed: (errorMessage: string | undefined) =>
        createAction(GlobalSettingsActionTypes.SaveFailed, { errorMessage }),

    // UI Actions
    setError: (errorMessage: string | undefined) => createAction(GlobalSettingsActionTypes.SetError, { errorMessage })
};

export type GlobalSettingsActions = ActionsUnion<typeof GlobalSettingsActions>;
